import Wix from 'Wix';

const lang = Wix.Utils.getLocale() || 'en';
//const lang = 'en'
let translations;
let locale;

try {
    translations = require(`../widget/translations/messages_${lang}`);
} catch (err) {
    translations = require('../widget/translations/messages_en');
}
try {
    locale = require(`react-intl/locale-data/${lang}`);
} catch (err) {
    locale = require('react-intl/locale-data/en');
}

export default { translations, locale, lang };



// WEBPACK FOOTER //
// ./src/utils/locale.widget.js